<template>
  <div class="date-data-cell">
    <div class="date-data-container">
      <div v-if="isLeaked" class="date-data-container__leak-date">
        {{ item.leakDate }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LeakDateTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isLeaked() {
      return this.item?.isLeaked;
    },
  },
};

</script>
<style scoped lang="scss">
@import '~@/assets/styles/design-system';

.email-data-cell{
  .date-data-container {
    display: flex;
    &__leak-date {
      color: var(--text-primary);
      font-size: rem(14);
      font-family: $font-family-regular;
    }
  }
}
</style>
